<app-layout>
  <router-outlet appScrollToTop></router-outlet>
</app-layout>

<app-chatbot></app-chatbot>
<app-image-lightbox></app-image-lightbox>

<div class="cookie-consent" *ngIf="showCookieBanner" role="dialog" aria-live="polite" aria-label="Cookie consent">
  <div class="cookie-consent__copy">
    <strong>Cookie preferences</strong>
    <span>We use cookies for analytics and ads measurement to improve PropDesk. You can accept or reject optional cookies.</span>
    <a routerLink="/privacy-policy">Privacy Policy</a>
  </div>
  <div class="cookie-consent__actions">
    <button type="button" class="cookie-consent__btn cookie-consent__btn--ghost" (click)="rejectCookies()">Reject</button>
    <button type="button" class="cookie-consent__btn" (click)="acceptCookies()">Accept</button>
  </div>
</div>

<div class="purchase-pending-toast purchase-pending-banner" *ngIf="checkoutReturn.showPurchasePendingBanner$ | async" role="status" aria-live="polite">
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="purchase-pending-spinner">
    <path d="M21 12a9 9 0 1 1-6.219-8.56"/>
  </svg>
  <span>Verifying your purchase — this can take up to a minute. It'll unlock automatically, no refresh needed.</span>
</div>

<div class="purchase-pending-toast purchase-pending-banner purchase-pending-banner--action" *ngIf="checkoutReturn.showSignInToClaim$ | async" role="status" aria-live="polite">
  <div class="purchase-pending-text">
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
      <polyline points="22 4 12 14.01 9 11.01"/>
    </svg>
    <span>If you completed checkout in the new tab, sign in with the <strong>same email you used at checkout</strong> to unlock your purchase.</span>
  </div>
  <button type="button" class="purchase-pending-signin-btn" (click)="checkoutReturn.signInToClaimPurchase()">Sign In</button>
</div>
